<ng-container *ngIf="(loading$ | async)">
    <div class="loading">
        <p-progressSpinner [style]="{width: '16px', height: '16px'}" styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
        <div class="label">{{'ui.results_list.loading' | translate}}</div>
    </div>
</ng-container>
<ng-container *ngIf="(error$ | async)">
    <div class="error">{{'ui.results_list.error' | translate}}</div>
</ng-container>
<ng-container *ngIf="!(loading$ | async) && !(error$ | async)">
    <ng-container *ngIf="clients && clients.length === 0">
      {{'ui.results_list.no_client_found' | translate}} <span (click)="cancelSearch()">{{'ui.results_list.try_again' | translate}}</span>
    </ng-container>
    <ng-container *ngIf="clients && clients.length > 0">
        <div class="list">
            <ng-container *ngFor="let client of clients">
                <div class="list-item">
                    <client-list-item [client]="client" (clientSelected)="handleClientSelected($event)"></client-list-item>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-container>
